// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueEquivalence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueEquivalence component
 */

import m from 'mobx-react';
import React, { Component } from 'react';
import PopupButton from 'modules/OperatorValue/Izenda.PopupButton';
import OperatorValueCheckBoxList from 'modules/OperatorValue/Izenda.OperatorValueCheckBoxList';
import OperatorValueComboTree from 'modules/OperatorValue/Izenda.OperatorValueComboTree';
import OperatorValueSelectBox from 'modules/OperatorValue/Izenda.OperatorValueSelectBox';
import OperatorValueCheckBoxPopupLazyLoading from './Izenda.OperatorValueCheckBoxPopupLazyLoading';
import OperatorValueSelectBoxLazyLoading from 'modules/OperatorValue/Izenda.OperatorValueSelectBoxLazyLoading';
import OperatorValueInputWithMode from 'modules/OperatorValue/Izenda.OperatorValueInputWithMode';
import { DATA_TYPES } from 'logic/data/Izenda.ReportDesignerConstants';
import AppGlobalConstants, { DATE_TIME_FORMAT, TIME_FORMAT } from 'logic/data/Izenda.AppGlobalConstants';
import moment from 'moment';
import uiState from 'logic/Izenda.UiState';
import { compose, withHandlers } from 'recompose';
import { identity, isNil, has } from 'lodash/fp';
/**
 * Datetime filter value
 * @type {Object}
 */
const comparisonFilterComponents = {
  'equals(popup)': {
    component: PopupButton
  },
  'equals(tree)': {
    component: OperatorValueComboTree
  },
  'equals(checkbox)': {
    component: OperatorValueCheckBoxList
  },
  'notequal(popup)': {
    component: PopupButton
  },
  'notequal(checkbox)': {
    component: OperatorValueCheckBoxList
  },
  'notequal(tree)': {
    component: OperatorValueComboTree
  },
  'equals(manualentry)': {
    component: OperatorValueSelectBox,
    subComponent: OperatorValueSelectBoxLazyLoading,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'equals(manualentrynoauto-complete)': {
    component: OperatorValueInputWithMode,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'notequal(manualentry)': {
    component: OperatorValueSelectBox,
    subComponent: OperatorValueSelectBoxLazyLoading,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'notequal(manualentrynoauto-complete)': {
    component: OperatorValueInputWithMode,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'equals(selection)': {
    component: OperatorValueSelectBox,
    subComponent: OperatorValueSelectBoxLazyLoading,
    props: {
      labelField: 'label',
      valueField: 'value',
      isSelect: true
    }
  },
  'notequal(selection)': {
    component: OperatorValueSelectBox,
    subComponent: OperatorValueSelectBoxLazyLoading,
    props: {
      labelField: 'label',
      valueField: 'value',
      isSelect: true
    }
  }
};

const action = compose(
  withHandlers({
    applyFormater: props => {
      const configField = props.configField || {};
      const fieldDetails = configField.fieldDetails || {};
      const dataType = fieldDetails.dataType;
      let applyFormater = identity;

      if (dataType === DATA_TYPES.DATE_TIME) {
        const displayDateFormat = uiState.currentUser.dateFormat;
        const displayDateTimeFomat = [displayDateFormat, TIME_FORMAT].join(' ');

        applyFormater = value => {
          const momentObject = moment(value, DATE_TIME_FORMAT, true);

          if (momentObject.isValid()) {
            return momentObject.format(displayDateTimeFomat);
          }
          return value;
        };
      }
      return applyFormater;
    }
  }),
  m.observer
);

const OperatorValueEquivalence = action(props => {
  const operator = props.filterInfo.operator || {};
  const key = operator.key;
  const componentInfo = comparisonFilterComponents[key];

  if (isNil(componentInfo)) {
    return null;
  }

  let Component = componentInfo.component;
  if (props.isLazyLoading && has('subComponent', componentInfo)) {
    Component = componentInfo.subComponent;
  }

  return <Component {...componentInfo.props} {...props} applyFormater={props.applyFormater} />;
});

OperatorValueEquivalence.displayName = 'OperatorValueEquivalence';

export default OperatorValueEquivalence;



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueEquivalence.jsx